import React, { useState } from 'react';
import UserList from './UserList';
import { FaUserAlt } from 'react-icons/fa';
import MenuHead from './MenuHead';
import { Select, Option } from '@material-tailwind/react';
import { useTranslation } from 'react-i18next';

const Dashboard = () => {
  const { t } = useTranslation();
  const [year, setYear] = useState('2023');

  return (
    <>
      <MenuHead />
      <div className="flex flex-row">
        <aside className="w-64" aria-label="Sidebar">
          <div className="overflow-y-auto min-h-80 py-4 px-3 bg-gray-50 dark:bg-blue-second">
            <ul className="space-y-2">
              <li>
                <div className="flex items-center p-2 text-base font-normal text-gray-900  dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700">
                  <FaUserAlt size={20} />
                  <span className="flex-1 ml-3 whitespace-nowrap">
                    List Clients
                  </span>
                </div>
              </li>
              <li>
                <Select
                  label={t('year')}
                  color="blue-gray"
                  value={year}
                  onChange={(target) => setYear(target)}
                >
                  <Option value="2023">2023</Option>
                  <Option value="users">2022</Option>
                </Select>
              </li>
            </ul>
          </div>
        </aside>
        <div className="px-3 w-full h-screen items-center text-center">
          <UserList currentYearAdmin={year} />
        </div>
      </div>
    </>
  );
};

export default Dashboard;
